import React, { useEffect, useRef } from 'react';
import { DataSet, Network } from 'vis-network/standalone/esm/vis-network';

const NetworkGraph = ({ report }) => {
  const networkRef = useRef(null);
  const networkInstance = useRef(null);

  useEffect(() => {
    if (!report || !report.analysis) return;

    // Extract top callers and destinations
    const { top_callers, top_call_destinations } = report.analysis;

    // Limit to top N entries if necessary
    const topN = 30;
    const limitedCallers = top_callers.slice(0, topN);
    const limitedDestinations = top_call_destinations.slice(0, topN);

    // Combine and deduplicate nodes
    const uniqueNodes = new Set();
    limitedCallers.forEach(([caller]) => uniqueNodes.add(caller));
    limitedDestinations.forEach(([destination]) => uniqueNodes.add(destination));

    const nodesArray = [
      { id: 'target', label: 'Target', color: '#ff5733' },
      ...Array.from(uniqueNodes).map((num) => ({
        id: num,
        label: num,
        color: limitedCallers.some(([caller]) => caller === num)
          ? '#33a1ff' // Incoming
          : '#33ff57', // Outgoing
      })),
    ];

    const nodes = new DataSet(nodesArray);

    // Create edges for incoming calls
    const incomingEdges = limitedCallers.map(([caller]) => ({
      from: caller,
      to: 'target',
      color: { color: '#0000ff' },
      arrows: 'to',
    }));

    // Create edges for outgoing calls
    const outgoingEdges = limitedDestinations.map(([destination]) => ({
      from: 'target',
      to: destination,
      color: { color: '#ff0000' },
      arrows: 'to',
    }));

    const edgesArray = [...incomingEdges, ...outgoingEdges];
    const edges = new DataSet(edgesArray);

    const data = { nodes, edges };
    const options = {
      // layout: {
      //   hierarchical: {
      //     direction: 'UD',
      //     sortMethod: 'hubsize',
      //   },
      // },
      nodes: {
        shape: 'dot',
        size: 20,
        font: {
          size: 14,
        },
      },
      edges: {
        width: 2,
        smooth: {
          type: 'cubicBezier',
          roundness: 0.4,
        },
        arrows: {
          to: { enabled: true, scaleFactor: 0.3 },
        },
      },
      physics: {
        hierarchicalRepulsion: {
          nodeDistance: 150,
        },
        solver: 'hierarchicalRepulsion',
      },
      interaction: {
        hover: true,
        navigationButtons: true,
        keyboard: true,
      },
    };

    // Initialize Network only once
    if (!networkInstance.current) {
      networkInstance.current = new Network(networkRef.current, data, options);
    } else {
      networkInstance.current.setData(data);
    }
  }, [report]);

  return <div ref={networkRef} style={{ height: '500px', border: '1px solid lightgray' }} />;
};

export default NetworkGraph;